import { useEffect, useState } from "react";
import { AiFillBackward } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useGetDealersQuery } from "../../features/api/dealerApi";
import { useGetCategoryQuery } from "../../features/api/categoryApi";
import { useGetProductQuery } from "../../features/api/productApi";
import {
  useAddProServiceMutation,
  useGetProServicesQuery,
} from "../../features/api/proserviceApi";
import NewClient from "./NewClient";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { useGetSubCategoryQuery } from "../../features/api/subcategoryApi";
import { useGetAllModelQuery } from "../../features/api/modelApi";
import { MdAdd } from "react-icons/md";
import { getuser } from "../../components/CommonDateFormat";

const CreateProService = () => {
  const navigate = useNavigate();
  const user = getuser();

  // fetch all dealer
  const { data: delr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = delr?.dealer;

  const categories = useGetCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.categories;

  const subCategory = useGetSubCategoryQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.brandData;

  const products = useGetProductQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  const productModels = useGetAllModelQuery(null, {
    refetchOnMountOrArgChange: true,
  })?.data?.data;

  // states name
  const [p_r_date, setProRecvDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [claim_date, setClaimDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [cat_name, setCategory] = useState(124);
  const [sub_catName, setSubCategory] = useState("");
  const [pro_name, setProduct] = useState("");
  const [war_type, setWarrantyType] = useState("");
  const [job_no, setJobNo] = useState("");
  const [client_name, setDealerName] = useState("");
  const [client_id, setClientId] = useState("");
  const [c_address, setCleintAddress] = useState("");
  const [mobile_no, setMobileNo] = useState("");

  const [complain_type, setComplainType] = useState("");
  const [model_no, setModelNo] = useState("");
  const [slNo, setSlNo] = useState("");
  const [nature_claim, setNatureOfClaims] = useState("");
  const [service_type, setServiceType] = useState("");
  const [service_details, setServiceDetails] = useState("");
  const [prev_jobNo, setPrevJobNo] = useState("");
  const [prev_job_date, setPrevJobDate] = useState("");
  const [p_rcve_loc, setProRcvLocation] = useState("");
  const [rcv_by, setReceiveBy] = useState("");
  const [del_app_date, setDeliveryDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [remarks, setRemarks] = useState("");
  const [accessories, setAccessories] = useState("");

  const { data: proServc } = useGetProServicesQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  // const proServices = proServc;

  // console.log(proServc);

  // let maxInvNo = 0;
  // proServices?.map((data) => {
  //   const chalanNo = data?.job_no;
  //   const chalanSeperate = chalanNo?.split("-")[1];
  //   const generateAgain = chalanSeperate?.split("/")[0];
  //   if (!isNaN(generateAgain) && +generateAgain > +maxInvNo) {
  //     maxInvNo = generateAgain;
  //   }
  // });
  // const generateInvoice = `SER-${+maxInvNo + 1}/23`;

  let maxJVNo = 10000;
  proServc?.forEach((data) => {
    const jvNo = data?.job_no;
    const separateInv = jvNo?.split("-");
    const separateInvAgain = separateInv?.[2];
    if (!isNaN(separateInvAgain) && +separateInvAgain > +maxJVNo) {
      maxJVNo = +separateInvAgain;
    }
  });
  const generateInvoice = `JOB-${new Date(p_r_date).getFullYear()}-${
    +maxJVNo + 1
  }`;

  const [inputValue, setInputValue] = useState("");
  const [auto, setAuto] = useState(null);
  const filteredOptions = dealers?.filter((dealer) =>
    dealer.d_name.toLowerCase().includes(inputValue.toLowerCase())
  );

  // set client info
  useEffect(() => {
    if (auto) {
      setClientId(auto?.id);
      setMobileNo(auto?.d_mobile);
      setCleintAddress(auto?.d_address);
    }
  }, [auto]);

  // create product service
  const [saveProductService] = useAddProServiceMutation();

  const handleCreateProductService = async () => {
    const data = {
      p_r_date,
      job_no: generateInvoice,
      client_id,
      model_id: model_no,
      slNo,
      war_type,
      complain_type,
      nature_claim,
      claim_date,
      service_type,
      service_details,
      prev_jobNo,
      prev_job_date: prev_job_date || null,
      p_rcve_loc,
      del_app_date,
      delivery_status: "Pending",
      rcv_by,
      remarks,
      accessories,
      created_by: user?.id,
    };

    try {
      const response = await saveProductService(data);
      console.log(response);
      const insertId = response?.data?.insertId;
      if (insertId) {
        navigate(`/dashboard/product-service/report/${insertId}`);
        toast.success("success");
        return;
      } else {
        toast.error("Something went wrong, Try again.");
      }
    } catch (error) {
      console.error("Error updating data:", error?.response);
    }
  };

  return (
    <div className="lg:h-[89vh] mx-auto overflow-auto  bg-[#dbd7d7]">
      <div className="p-4">
        <h1 className="text-2xl font-bold text-center">
          Product Service Center
        </h1>
        <div className="flex items-center justify-end gap-x-2">
          <Link
            to="/dashboard/orders/create"
            className="text-white bg-blue-500 cursor-pointer flex items-center px-3 rounded py-1"
          >
            {" "}
            <span>
              <MdAdd className="text-2xl" />
            </span>
            <span>New Bill</span>
          </Link>

          <NewClient />

          <Link
            to="/dashboard/product-services"
            className="bg-blue-500 px-2 py-1 rounded text-white flex items-center gap-x-1"
          >
            <AiFillBackward /> Back{" "}
          </Link>
        </div>
      </div>
      <div className="">
        <div className="p-4 m-4 border">
          <h2 className="font-semibold mb-4 text-xl bg-blue-500 text-white text-center py-1">
            Service Product Information
          </h2>
          <form className=" grid grid-cols-1 lg:grid-cols-2  gap-6">
            <div className="flex gap-1">
              <label className="w-[40%]">Product Receive Date</label>
              <input
                type="date"
                value={p_r_date}
                onChange={(e) => setProRecvDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Job No</label>
              <input
                type="text"
                value={generateInvoice}
                disabled
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Client Name</label>
              <Autocomplete
                value={auto}
                onChange={(event, newValue) => {
                  setAuto(newValue);
                }}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                options={filteredOptions}
                size="small"
                className=" bg-[#e7e4e4] w-[60%]"
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Client" />
                )}
                getOptionLabel={(option) => option.d_name}
                getOptionSelected={(option, value) => option.id === value}
              />
            </div>

            <div className="flex gap-1">
              <label className="w-[40%]">Cleint Address</label>

              <textarea
                value={c_address}
                disabled
                // onChange={(e) => setCleintAddress(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Mobile No.</label>
              <input
                type="text"
                value={mobile_no}
                disabled
                // onChange={(e) => setMobileNo(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className="w-[40%]">Category</label>
              <select
                onChange={(e) => setCategory(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option>--select--</option>
                {categories?.map((cat) => (
                  <option key={cat?.id} value={cat?.id}>
                    {cat?.cat_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Brand</label>
              <select
                onChange={(e) => setSubCategory(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option>--select--</option>
                {subCategory
                  ?.filter((item) => item?.cat_name == cat_name)
                  ?.map((sCat) => (
                    <option key={sCat?.id} value={sCat?.id}>
                      {sCat?.sub_catName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Product</label>
              <select
                onChange={(e) => setProduct(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option>--select--</option>
                {products
                  ?.filter((item) => item?.sub_catName == sub_catName)
                  ?.map((product) => (
                    <option key={product?.id} value={product?.id}>
                      {product?.product_name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Models</label>
              <select
                onChange={(e) => {
                  setModelNo(e.target.value);
                }}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option>--select--</option>
                {productModels
                  ?.filter((model) => model.product_id === +pro_name)
                  .map((model) => (
                    <option key={model?.model_id} value={model?.model_id}>
                      {model?.model_name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">P. Serial No.</label>
              <input
                type="text"
                value={slNo}
                onChange={(e) => setSlNo(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className="w-[40%]">Warranty Type</label>
              <select
                value={war_type}
                onChange={(e) => setWarrantyType(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Warranty">Warranty</option>
                <option value="Non-Warranty">Non-Warranty</option>
                <option value="Others">Others</option>
              </select>
            </div>

            <div className="flex gap-1">
              <label className="w-[40%]">Complain Type</label>
              <select
                value={complain_type}
                onChange={(e) => setComplainType(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Regular">Regular</option>
                <option value="Re-complain">Re-complain</option>
              </select>
            </div>
          </form>
        </div>

        <div className="p-4 m-4 border">
          <h2 className="font-semibold mb-4 text-xl bg-blue-500 text-white text-center py-1">
            Service Details Information
          </h2>
          <form className=" grid grid-cols-1 lg:grid-cols-2  gap-6">
            <div className="flex gap-1">
              <label className=" w-[40%]">Nature of Claims</label>

              <textarea
                value={nature_claim}
                onChange={(e) => setNatureOfClaims(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Claim Date</label>
              <input
                type="date"
                value={claim_date}
                onChange={(e) => setClaimDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Service Type</label>
              <select
                value={service_type}
                onChange={(e) => setServiceType(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Indoor">Indoor</option>
                <option value="Out Door">Out Door</option>
              </select>
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Service Details</label>
              <textarea
                value={service_details}
                onChange={(e) => setServiceDetails(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Previous Job No.</label>
              <input
                type="text"
                value={prev_jobNo}
                onChange={(e) => setPrevJobNo(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Previous Job Date</label>
              <input
                type="date"
                value={prev_job_date}
                onChange={(e) => setPrevJobDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            <div className="flex gap-1">
              <label className=" w-[40%]">Product Receive Location</label>
              <input
                type="text"
                value={p_rcve_loc}
                onChange={(e) => setProRcvLocation(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]"> Delivery Date ( Approx )</label>
              <input
                type="date"
                value={del_app_date}
                onChange={(e) => setDeliveryDate(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>

            {/* <div className="flex gap-1">
              <label className=" w-[40%]">Present Status</label>
              <select
                onChange={(e) => setWorkingStatus(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              >
                <option value="">--select--</option>
                <option value="Pending">Pending</option>
                <option value="Under Repair">Under Repair</option>
                <option value="Done Successfully">Done Successfully</option>
              </select>
            </div> */}
            <div className="flex gap-1">
              <label className=" w-[40%]">Remarks</label>
              <textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Received By</label>
              <input
                type="text"
                value={rcv_by}
                onChange={(e) => setReceiveBy(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
            <div className="flex gap-1">
              <label className=" w-[40%]">Accessories</label>
              <textarea
                value={accessories}
                onChange={(e) => setAccessories(e.target.value)}
                className="border border-gray-400 h-10 rounded focus:outline-blue-600 px-2 bg-[#e7e4e4] w-[60%]"
              />
            </div>
          </form>
        </div>

        <div className="flex justify-end px-4">
          <button
            onClick={handleCreateProductService}
            className=" px-4 py-1 rounded bg-blue-500 text-white mb-4"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateProService;
